import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchRelationShoppings } from '@/actions/shopping';
import useIdea from '@/hooks/useIdea';
import useIdeaList from '@/hooks/useIdeaList';
import useShoppingList from '@/hooks/useShoppingList';

export default function useIdeaDetail() {
  const dispatch = useDispatch();
  const [idea, error] = useIdea();
  const ideaList = useIdeaList();
  const shoppingList = useShoppingList();
  useEffect(() => {
    idea && dispatch(fetchRelationShoppings(idea.fields.relationShoppingList));
  }, [dispatch, idea]);

  return [idea, ideaList, shoppingList, error.status] as const;
}
